<template lang="pug">
  v-layout.column.sheet-details(v-rc-loader="!loaded([]) || loading")
    v-layout.justify-center.grey.lighten-5(v-if="sheet")
      v-flex.xs12.lg6.pt-4
        v-card.mb-4
          v-card-text.text-xs-center
            .display-1.mb-3 {{ sheet.raison_sociale }}
            v-layout.justify-center
              v-flex.xs10
                v-img.mb-3(v-if="sheet.medias[0]" aspect-ratio="1.4" :src="resizeSheetImage(sheet.medias[0].url)")
                v-img.mb-3(v-else aspect-ratio="1.4" src="http://savings.gov.pk/wp-content/plugins/ldd-directory-lite/public/images/noimage.png")
            span.subheading {{ categories[sheet.bordereau.toLowerCase()] }},
            span.subheading  {{ sheet.commune }}
            span.subheading(v-if="sheet.code_postal && sheet.code_postal.length")   ({{ sheet.code_postal }})
            .subheading(v-if="sheet.source_identifier") Identifiant SIT source : {{ sheet.source_identifier }}
            v-layout.justify-center
              v-flex.xs10
                v-divider.mt-3(v-if="hasSITRole")
                v-layout.click.hover-highlight.align-center.py-1.px-2(v-if="client && hasSITRole" @click="$router.push({ name: 'client_sheets', params: { clientId: client.id }})")
                  v-avatar(v-if="client.image_url" size="60")
                    v-img(alt="clientImage" :src="client.image_url")
                  v-icon(v-else size="60") store_mall_directory
                  .title.pl-4 {{ client.name }}, {{ client.city }}
                  v-flex
                    v-layout.justify-end
                      v-btn.text-xs-right(depressed fab color="error" small @click.stop="seperateClient")
                        v-icon(medium dark) delete
                div(v-else-if="hasSITRole")
                  v-layout.px-2.py-3.justify-center.align-center.detail-link(@click="openClientAssociateDialog")
                    .title Associer à un compte
                  v-dialog(width="90%" persistent v-model="associateClientOpen")
                    v-card
                      v-card-title.white--text.title.primary.elevation-4
                        v-layout.justify-center.align-center
                          v-flex.xs10.offset-xs1.text-xs-center DÉFINIR UN COMPTE
                          v-flex.xs1.text-xs-right
                            v-icon(large dark @click="associateClientOpen = false") close
                      v-card-text.associate-sheet-card-text.pa-0
                        rc-clients-list(:add="false" :customActions="clientsActions" @attach="attachToClient" ref="clientsList" :clickToVisit="false")
</template>

<script>
import axios from 'axios';
import RcClient from '@/components/RcClient/RcClient.vue';
import RcClientsList from '@/components/RcClients/RcClientsList.vue';
import apiSheetService from '@/services/api/ambassador/sheetService';
import apiClientService from '@/services/api/ambassador/clientService';

export default {
  components: {
    RcClientsList,
    RcClient,
  },
  data() {
    return {
      sheet: null,
      client: null,
      clientsActions: [
        { icon: 'add', eventKey: 'attach', tooltip: 'Associer la fiche à ce client' },
      ],
      associateClientOpen: false,
      ready: false,
      loading: false,
    }
  },
  mounted() {
    this.getSheet(this.$route.params.sheetId)
      .then(() => {
        this.getClient();
      })
  },
  methods: {
    openClientAssociateDialog() {
      setTimeout(() => {
        this.associateClientOpen = true;
      }, 0);
    },
    resizeSheetImage(url) {
      return `http://api.tourism-system.com/resize/clip/800/600/80/${btoa(unescape(encodeURIComponent(url))).replace('/', '_')}/image.jpg`;
    },
    async seperateClient() {
      this.loading = true;
      if (await apiSheetService.unbindFromClient(this.sheet, this.sheet.owner_for_client_id)) {
        this.client = null;
      }
      this.loading = false;
    },
    async attachToClient(client) {
      this.$refs.clientsList.loading = true;
      if (await apiSheetService.affectToClient(this.sheet, client.id)) {
        this.client = client;
      }
      this.associateClientOpen = false;
      this.$refs.clientsList.loading = true;
    },
    async getClient() {
      this.client = await apiClientService.getById(this.sheet.owner_for_client_id);
      this.ready = true;
    },
    async getSheet(sheetId) {
      this.sheet = await apiSheetService.getById(sheetId);
      this.ready = true;
    },
  },
  computed: {
    hasSITRole() {
      return !!this.$store.state.app.user.roles.includes('mes_utilisateurs_onglet_fiches_sit');
    },
    categories() {
      return this.$store.state.app.sheetCategories;
    },
    loaded(refs) {
      return refs => this.ready && refs.every(it => this.$refs[it] && this.$refs[it].loaded);
    },
  },
}
</script>

<style lang="scss">
  .sheet-details {
    height: calc(100vh - 160px);
  }

  .associate-sheet-card-text {
    height: calc(90vh - 68px);
    overflow-y: auto;
    .clientContacts {
      height: 100%;
    }
  }

  .detail-link {
    cursor: pointer;
    &:hover {
      background-color: #cecece;
    }
  }
</style>
